<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Boards" title="Enclosure" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">

					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="enclosurePending()">
												<option value="10">10</option>
												<option value="20">20</option>
												<option value="50">50</option>
												<option value="100">100</option>
												<option value="200">200</option>
											</select>
											<span>entries</span>
										</label>
									</div>
                                    <div class="col-md-2">
										<div class="page-loader" v-if="Boolean(selectedBoards.length)">
											<button type="button" class="btn btn-info" v-if="!loading" @click="generateBarcode()">Barcode</button>
											<img class="page-loader float-end" v-else src="@/assets/images/ajax-loader.gif"/>
										</div>
									</div>

                                    <div class="col-md-2 float-end">
										<input type="text" v-model="keyword" @keyup="enclosurePending()" class="form-control" placeholder="Search"/>
									</div>
								</div>
							</div>
		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>
                                            <th>IMEI & ICCID</th>
                                            <th>Serial Number</th>
                                            <th>Primary <br>No.</th>
                                            <th>Secondary <br>No.</th>
											<th>SIM</th>
											<th>Firmware By</th>
                                            <th>Status</th>
                                            <th>Action<br>
												Select All &nbsp;<input type="checkbox" v-model="selectAll" @change="toggleAllSelection" /> 
											</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="Boolean(boards.length)">
                                        <tr v-for="(board, index) in boards" :key="board.id" align="center">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ board.imei }}
												<br>{{ board.iccid }}
											</td>
                                            <td>{{ board.serial_number || '-' }}</td>
                                            <td>{{ board.primary_mobile_number }}</td>
                                            <td>{{ board.secondary_mobile_number }}</td>
											<td>{{ board.sim }}</td>
											<td>{{ board.firmware_success_user_name }}
												<br>{{ board.firmware_success_date }}
											</td>
                                            <td>
                                                <span v-if="board.status == 1">
													<span class="badge rounded-pill bg-info">Pending</span>
												</span>
												<span v-if="board.status == 2">
													<span class="badge rounded-pill bg-success">Completed</span>
												</span>
												<span v-if="board.status == 3">
													<span class="badge rounded-pill bg-secondary">To Vendor</span>
												</span>
												<span v-if="board.status == 4">
													<span class="badge rounded-pill bg-warning">Enclosure Pending</span>
												</span>
                                            </td>
                                            <td>
                                                <button class="btn btn-info btn-sm me-2 mb-2" @click="openUpdateSerialModal(board)">Update Serial</button>
                                                <input type="checkbox" v-model="selectedBoards" :value="board.id" />
                                            </td>
                                        </tr>
									</tbody>

									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(boards.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="enclosurePending(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<!-- <label class="control-label">Logo </label> -->
							<input class="form-control" type="file" accept=".xls, .xlsx" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<!-- Update Serial Number Modal -->
		<div class="modal fade" id="updateSerialModal" tabindex="-1" aria-labelledby="updateSerialModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="updateSerialModalLabel">Update Serial Number</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="updateSerialNumber" enctype="multipart/form-data">
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">IMEI</label>
									<input v-model="selectedBoardForSerialUpdate.imei" class="form-control" disabled/>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Current Serial Number</label>
									<input v-model="selectedBoardForSerialUpdate.serial_number" class="form-control" disabled/>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Device Model<span class="text-danger">*</span></label>
									<select v-model="serialUpdateDeviceModelId" class="form-select" required>
										<option value="">Select Device Model</option>
										<option v-for="model in deviceModels" :key="model.id" :value="model.id">{{ model.modelName }}</option>
									</select>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">New Serial Number<span class="text-danger">*</span></label>
									<div class="input-group">
										<span class="input-group-text bg-light" style="min-width: 7ch; font-family: monospace;">{{ serialPrefix }}</span>
										<input v-model="serialSuffix" type="text" class="form-control" placeholder="Enter suffix (editable part)" :disabled="!serialUpdateDeviceModelId" />
									</div>
									<small class="text-muted">First 7 characters (prefix) are from the selected device model and cannot be edited.</small>
									<span v-if="errors.serial_number" class="text-danger small d-block">{{ errors.serial_number }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 form-group mt-3">
									<button type="submit" class="btn btn-primary me-3" :disabled="isSubmittingSerial">
										<span v-if="isSubmittingSerial">Saving...</span>
										<span v-else>Save</span>
									</button>
									<button type="button" class="btn btn-light" @click="closeUpdateSerialModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	  
   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Coupons eport",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				accessories: [],
				pagination: {},
				from: 0,
				to: 0,
				total: 0,
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,
				modal_title: "Upload Excel",
				button_title: "Upload",

                boards: [],

                selectedBoards: [],
            	selectAll: false,
                loading: false,
				selectedBoardForSerialUpdate: {
					id: null,
					imei: "",
					serial_number: "",
					device_model_id: null
				},
				serialUpdateDeviceModelId: "",
				serialSuffix: "",
				deviceModels: [],
				isSubmittingSerial: false,
				errors: {},

			};
		},
		computed: {
			serialPrefix() {
				if (!this.serialUpdateDeviceModelId) return "";
				const model = this.deviceModels.find(m => m.id == this.serialUpdateDeviceModelId);
				if (!model) return "";
				const combined = (model.manufacturer || "") + (model.model || "") + (model.test_agency || "");
				return combined.substring(0, 7).padEnd(7);
			},
		},
		mounted() {},

		created() {
			this.enclosurePending();
			this.fetchDeviceModels();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			enclosurePending(page_url = null) {
				this.getToken();
				let url = "/staffs/enclosuePendingBoardsList?limit=" + this.listing_length  +  "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.boards = responseData.data;
						this.pagination = responseData.links;
						this.from = responseData.from;
						this.to = responseData.to;
						this.total = responseData.total;
						
					})
					.catch((err) => console.log(err));
			},
			

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

            toggleAllSelection() {
				if (this.selectAll) {
					// If "Select All" is checked, select all users
					this.selectedBoards = this.boards.map(board => board.id);
				} else {
					// If "Select All" is unchecked, deselect all users
					this.selectedBoards = [];
				}
			},

			generateBarcode() {
				this.getToken();

				const params = new URLSearchParams();
				var i = 0;
					this.selectedBoards.forEach(obj => {
						
						params.append('board_ids[' + i + ']', obj);
						i++;
					});

				let page_url = "/staffs/generateBarcode?" + params.toString();
				this.loading = true;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {
					console.log("Response received:", response);
					console.log("Response status:", response.status);
					console.log("Response headers:", response.headers);
					console.log("Response data length:", response.data.byteLength);
					
					// Check response size - if it's very small, it's likely JSON, not PDF
					if (response.data.byteLength < 1000) {
						try {
							const decoder = new TextDecoder('utf-8');
							const jsonString = decoder.decode(response.data);
							console.log("Decoded response:", jsonString);
							
							if (jsonString.trim().startsWith('{')) {
								const jsonResponse = JSON.parse(jsonString);
								console.log("Parsed JSON:", jsonResponse);
								
								if (jsonResponse.status === false || jsonResponse.status === "false") {
									this.loading = false;
									const errorMessage = jsonResponse.message || "Failed to generate barcode";
									console.log("Error detected - showing swal:", errorMessage);
									this.$swal("", errorMessage, "error");
									return Promise.reject(new Error(errorMessage));
								}
							}
						} catch (e) {
							console.error("Error parsing response:", e);
						}
					}
					
					// Always try to decode and check for JSON (in case response is larger)
					try {
						const decoder = new TextDecoder('utf-8');
						const jsonString = decoder.decode(response.data);
						
						// Check if it looks like JSON (starts with {)
						if (jsonString.trim().startsWith('{')) {
							const jsonResponse = JSON.parse(jsonString);
							
							if (jsonResponse.status === false || jsonResponse.status === "false") {
								this.loading = false;
								const errorMessage = jsonResponse.message || "Failed to generate barcode";
								console.log("Error detected in response:", errorMessage);
								this.$swal("", errorMessage, "error");
								return Promise.reject(new Error(errorMessage));
							}
						}
					} catch (e) {
						// Not JSON, proceed with PDF processing
						console.log("Response is not JSON, proceeding with PDF processing");
					}

					// Process as PDF
					let blob = new Blob([response.data], { type: "application/pdf" });
					var blob_url = window.URL.createObjectURL(blob);
					let iframe =  document.createElement('iframe'); //load content in an iframe to print later
					document.body.appendChild(iframe);
					iframe.style.display = 'none';
					iframe.src = blob_url;

					return new Promise((resolve) => { 
						window.setTimeout(() => {
							iframe.contentWindow.print();
							resolve();
						}, 1000);
					});
					
				})
				.then(() => {
					this.loading = false;
					this.selectedBoards = [];
					this.$swal("Barcode generated successfully", "", "success");
					this.enclosurePending();
				})
				.catch((err) => {
					console.log("Error caught:", err);
					console.log("Error response:", err.response);
					console.log("Error message:", err.message);
					this.loading = false;
					
					// Try to extract error message from response
					let errorMessage = "Failed to generate barcode";
					
					if (err.response) {
						
						if (err.response.data) {
							try {
								// If response is arraybuffer, try to decode it
								if (err.response.data instanceof ArrayBuffer) {
									console.log("Response data is ArrayBuffer, decoding...");
									const decoder = new TextDecoder('utf-8');
									const jsonString = decoder.decode(err.response.data);
									console.log("Decoded string:", jsonString);
									
									// Try to parse as JSON
									try {
										const jsonResponse = JSON.parse(jsonString);
										console.log("Parsed JSON response:", jsonResponse);
										
										if (jsonResponse.message) {
											errorMessage = jsonResponse.message;
										} else if (jsonResponse.data && jsonResponse.data.message) {
											errorMessage = jsonResponse.data.message;
										}
									} catch (parseError) {
										console.log("Not valid JSON, using decoded string");
										errorMessage = jsonString || "Failed to generate barcode";
									}
								} else if (typeof err.response.data === 'string') {
									console.log("Response data is string, parsing...");
									// Try to parse as JSON string
									try {
										const jsonResponse = JSON.parse(err.response.data);
										console.log("Parsed JSON:", jsonResponse);
										if (jsonResponse.message) {
											errorMessage = jsonResponse.message;
										}
									} catch (e) {
										// Not JSON, use the string as is
										errorMessage = err.response.data;
									}
								} else if (err.response.data && typeof err.response.data === 'object') {
									console.log("Response data is object:", err.response.data);
									if (err.response.data.message) {
										errorMessage = err.response.data.message;
									} else if (err.response.data.data && err.response.data.data.message) {
										errorMessage = err.response.data.data.message;
									}
								}
							} catch (e) {
								console.error("Error parsing error response:", e);
								// If parsing fails, use default message
								if (err.response.data && err.response.data.message) {
									errorMessage = err.response.data.message;
								}
							}
						}
					}
					
					console.log("Final error message to display:", errorMessage);
					this.$swal("", errorMessage, "error");
				});
		
			},

			openUpdateSerialModal(board) {
				const modelId = board.model_id ?? board.device_model_id;
				this.selectedBoardForSerialUpdate = {
					id: board.id,
					imei: board.imei || "",
					serial_number: board.serial_number || "",
					device_model_id: modelId || null
				};
				this.serialUpdateDeviceModelId = modelId ? String(modelId) : "";
				this.serialSuffix = (board.serial_number && board.serial_number.length >= 7) ? board.serial_number.substring(7) : "";
				this.errors = {};
				if (this.deviceModels.length === 0) {
					this.fetchDeviceModels();
				}
				const modal = new Modal(document.getElementById('updateSerialModal'));
				modal.show();
			},

			closeUpdateSerialModal() {
				const modal = Modal.getInstance(document.getElementById('updateSerialModal'));
				if (modal) {
					modal.hide();
				}
				this.selectedBoardForSerialUpdate = {
					id: null,
					imei: "",
					serial_number: "",
					device_model_id: null
				};
				this.serialUpdateDeviceModelId = "";
				this.serialSuffix = "";
				this.errors = {};
			},

			fetchDeviceModels() {
				this.getToken();
				this.$axios
					.get("/staffs/getDeviceModel", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						if (res.data.status && res.data.data) {
							this.deviceModels = res.data.data;
						} else {
							this.deviceModels = [];
						}
					})
					.catch((err) => {
						console.log(err);
						this.deviceModels = [];
					});
			},

			updateSerialNumber() {
				this.getToken();
				this.errors = {};
				this.isSubmittingSerial = true;

				// Validation
				if (!this.serialUpdateDeviceModelId) {
					this.errors.serial_number = "Please select a device model";
					this.isSubmittingSerial = false;
					return;
				}
				const fullSerial = this.serialPrefix + (this.serialSuffix || "");
				if (!fullSerial.trim()) {
					this.errors.serial_number = "Serial number is required";
					this.isSubmittingSerial = false;
					return;
				}

				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let url = "staffs/updateSerialNumber";
				let formData = new FormData();
				formData.append("board_id", this.selectedBoardForSerialUpdate.id);
				formData.append("model_id", this.serialUpdateDeviceModelId);
				formData.append("serial_number", fullSerial.trim());

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message || "Serial number updated successfully", "success");
							this.closeUpdateSerialModal();
							this.enclosurePending();
						} else {
							this.$swal("", response.data.message || "Failed to update serial number", "error");
						}
						this.isSubmittingSerial = false;
					})
					.catch((error) => {
						console.log(error);
						this.isSubmittingSerial = false;
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

		},
	};
</script>
